import { FooterContent } from '@/configs/footer/footer.config';
import { ERRORS } from '@/constants/error';
import { useAppContext } from '@/providers/app-provider/app-provider';

const useFooterContent = (): FooterContent => {
  const context = useAppContext();
  if (!context.footerConfig) {
    throw ERRORS.REGULAR('footerConfig file could not be found');
  }

  return context.footerConfig;
};

export default useFooterContent;
